import React from 'react';
import { FiChevronDown, FiChevronRight, FiFileText, FiFolder, FiFolderMinus } from 'react-icons/fi';

export default function SkillFolderTree({ nodes, expanded, onToggle, selected, onSelect, language }) {
  return <ul className="skill-folder-tree">
    {nodes.map(node => <li key={node.path}>
      {node.children ? <>
        <button type="button" className="skill-folder" aria-label={`${language === 'en' ? 'Folder' : 'Map'} ${node.path}`} aria-expanded={expanded.has(node.path)} onClick={() => onToggle(node.path)}>
          {expanded.has(node.path) ? <FiChevronDown aria-hidden="true" /> : <FiChevronRight aria-hidden="true" />}
          {expanded.has(node.path) ? <FiFolderMinus aria-hidden="true" /> : <FiFolder aria-hidden="true" />}<span>{node.name}/</span>
        </button>
        {expanded.has(node.path) && <SkillFolderTree nodes={node.children} expanded={expanded} onToggle={onToggle} selected={selected} onSelect={onSelect} language={language} />}
      </> : <button type="button" className="skill-file" aria-label={node.path} aria-pressed={selected === node.path} onClick={() => onSelect(node.path)}><FiFileText aria-hidden="true" /><span>{node.name}</span></button>}
    </li>)}
  </ul>;
}
